import { render, staticRenderFns } from "./Privado.vue?vue&type=template&id=83e3b6f0"
import script from "./Privado.vue?vue&type=script&lang=js"
export * from "./Privado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports